export const DiscussionFormKeys = {
  COMMENT: 'comment',
  FURTHER_ACTION: 'furtherAction',
  FORM: 'form',
  ID: 'id',
  ROW_VERSION: 'rowVersion',
  STATUS: 'status',
  IS_ISSUE_COMMENT: 'isIssueComment',
  IS_ISSUE_REPLY: 'isIssueReply',
};
